<section class="card allMeetings" order-id="card-5">
  <div class="card-header">
    <div class="header-title-section">
      <h5 class="mb-0 d-inline-block">
        All Meetings
      </h5>
      <div class="header-icons-group">
        <a href="javascript:void();" (click)="addMeeting()" class="header-icon-btn" title="Add Meeting">
          <span>+</span>
        </a>
        <div class="header-icon-btn" [ngClass]="{'active': isCalenderVisible}" (click)="showCalender()" title="Calendar View">
          <i class="far fa-calendar-alt"></i>
        </div>
        <div class="header-icon-btn" [ngClass]="{'active': !isCalenderVisible}" (click)="showList()" title="List View">
          <i class="fas fa-bars"></i>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isCalenderVisible; then calender else list">here is ignored</div>
  <ng-template #calender>
    <app-calendar-task [refreshData]="refreshData" [rowFive]="rowFive" (outputStatus)="calenderOutputStatus"></app-calendar-task>
  </ng-template>
  <ng-template #list>
    <div [appHasPermission]="{'Url': 'meetings', 'method':'get', 'menu': 'Dashboard'}" class="dashboard-meetings-list-host">
      <app-dashboard-meetings-list [refreshData]="refreshData"></app-dashboard-meetings-list>
    </div>
    <div [appHasPermission]="{'Url': 'chat', 'method':'get', 'menu': 'Dashboard'}" *ngIf="isRocketChatRemove!='true'">
      <app-chats></app-chats>
    </div>
  </ng-template>
</section>